import { render, staticRenderFns } from "./mem_inside_kadru.vue?vue&type=template&id=1f6b2a10&scoped=true&"
import script from "./mem_inside_kadru.vue?vue&type=script&lang=js&"
export * from "./mem_inside_kadru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6b2a10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f6b2a10')) {
      api.createRecord('1f6b2a10', component.options)
    } else {
      api.reload('1f6b2a10', component.options)
    }
    module.hot.accept("./mem_inside_kadru.vue?vue&type=template&id=1f6b2a10&scoped=true&", function () {
      api.rerender('1f6b2a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/addon/kadru/mem_inside_kadru.vue"
export default component.exports